'use strict';


export default function() {
	return {
		link: postLink,
	}

	function postLink(scope, element, attrs) {
		element.addClass('action-toolbar');
	}
}
